












import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import { productNoPermissionList } from '@/api/product';
@Component({
  name: 'ams-search-product',
  components: {},
})
export default class AMSSearchProduct extends Vue {
  productList?: Array<any> = [];
  search: string = '';
  /* 过滤掉已选择的商品 */
  /**props */

  @Prop({
    default: () => {
      return [];
    },
  })
  selectedItems!: Array<any>;
  @Prop({default: null, }) isHidden!: boolean; //搜索商品过滤隐藏商品
  @Prop({default: false,}) isOnSale!: boolean;
  get selectedProducts() {
    return this.selectedItems.filter((s) => {
      if (s.id) {
        return s;
      }
    });
  }

  /* 过滤掉已选择的商品 */
  getProductList(value: string) {
    const param = this.isHidden!==null? {
      status: this.isOnSale ? 'OnSale' : null,
      filter: value,
      isHidden: this.isHidden,
    }:{ status: this.isOnSale ? 'OnSale' : null, filter: value }
    productNoPermissionList(param).then((data: any) => {
      this.productList = data.items.filter((i: any) => {
        if (
          this.selectedProducts
            .map(s => {
              return s.productId || s.id;
            })
            .indexOf(i.id) < 0
        ) {
          i.value = i.id;
          i.text = i.name;
          return i;
        }
      });
    });
  }
  autoComplete(value: any) {
    this.$emit('autoComplete', value);
  }
  @Watch('search', { immediate: true, deep: true })
  onValueChange(newValue: any, oldValue: any) {
    newValue && this.getProductList(newValue);
  }
}
